export default __webpack_public_path__ + "static/media/high-speed-solution.7dfbf93a.png";